var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconComputer = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3C21.6569 3 23 4.34315 23 6V15C23 16.6569 21.6569 18 20 18H14.75C14.75 18.1801 14.7981 18.3602 14.8944 18.5528C15.1765 19.117 15.6125 19.6983 16.2071 20.2929C16.8371 20.9229 16.3909 22 15.5 22H8.5C7.6091 22 7.16293 20.9229 7.79289 20.2929C8.38749 19.6983 8.82347 19.117 9.10557 18.5528C9.20168 18.3606 9.24982 18.1808 9.25 18.001L4 18C2.34315 18 1 16.6569 1 15V6C1 4.34315 2.34315 3 4 3H20ZM12.75 18L11.25 18.001C11.2498 18.4872 11.1313 18.9734 10.8944 19.4472C10.8018 19.6325 10.6988 19.8167 10.5854 20H13.4146C13.3012 19.8167 13.1982 19.6325 13.1056 19.4472C12.8685 18.9731 12.75 18.4866 12.75 18ZM20 5H4C3.44772 5 3 5.44772 3 6V15C3 15.5523 3.44772 16 4 16H20C20.5523 16 21 15.5523 21 15V6C21 5.44772 20.5523 5 20 5Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconComputer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconComputer.dcfcf955b3977d1c1fc5ee74435e711c.svg";